// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lS_F","content":"styles_content__3tfLd"};